import { connect } from 'react-redux'
import { RefundTransactionModal } from '../../../components/riders/riderdetails/wallet/RefundTransactionModal'
import { IRefundTransactionDTO, IStoreState } from '../../../types'
import * as actions from '../../../state/actions/riders'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const orgId = state.organizations.currentOrgId
  return {
    refundDetails: state.riders.rider.refundDetails,
    refundedAmount: state.riders.rider.refundedAmount ? state.riders.rider.refundedAmount : 0
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getRefundedAmount: (stripeTransactionId: string, walletId: string) => {
      dispatch(actions.getRefundedAmount(stripeTransactionId, walletId))
    },
    refundPayment: (params: IRefundTransactionDTO, refundableAmount: number) => {
      return dispatch(actions.refundPayment(params, refundableAmount))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RefundTransactionModal)



// WEBPACK FOOTER //
// ./src/containers/riders/riderdetails/RefundTransactionModal.ts